<template>
  <div
    class="modal"
    id="InspectLogViewer"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    style="display: none;"
  >
    <div class="modal-dialog" style="width:440px">
      <div class="modal-content">
        <!--Modal header-->
        <div class="modal-header">
          <h4 class="modal-title">反馈记录</h4>
        </div>
        <!--Modal body-->
        <div class="modal-body" style="padding-top:0">
          <ul>
            <li v-for="log in logs">
              <span class="log-time"> {{ timeFormat(log.created_at) }}</span>
              <span class="log-text text-primary m-l-10"> {{ log.desc }} </span>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button data-dismiss="modal" class="btn btn-default" type="button">
            关闭
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMomentLib from 'vue-moment-lib'
Vue.use(VueMomentLib)
export default {
  props: {
    logs: {
      type: Array,
      default: []
    }
  },
  methods: {
    timeFormat(datetime) {
      const time = new Date(datetime)
      return Vue.time(time).format('YYYY-MM-DD HH:MM')
    }
  }
}
</script>

<style scoped>
.log-text {
  font-size: 14px;
}
.log-time {
  font-size: 14px;
}
</style>